/*
 * @Author: zhu.huijun
 * @Date: 2021-05-18 14:23:12
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-02-21 17:22:46
 */
import React, { useState, useEffect } from 'react';
import { i18n } from 'fishx';
import get from 'lodash/get';

import { Radio } from '@whalecloud/fdx';
import PlanDetail from './PlanDetail';

import { renderPrice } from '@/utils';
import detailSvg from '@/assets/img/dscmPortal/offerDetails.svg';

import styles from './index.module.less';

const CardItem = props => {
  const { cardInfo = {}, isSelected, onClick } = props;
  const [comVisible, setComVisible] = useState(false);
  const [comMask, setComMask] = useState(false); // 判断offer是否可以被订购
  const comboUnitOfferDtoList = get(cardInfo, 'offerExtMap.comboUnitOfferDtoList') || [];
  const servType = get(cardInfo, 'servType') || get(cardInfo, 'offerExtMap.servType') || '';

  const handleClick = e => {
    e.stopPropagation();
    setComVisible(!comVisible);
  };

  useEffect(() => {
    const maskFlag = comboUnitOfferDtoList.some(comboUnitOfferItem => comboUnitOfferItem.isCannotOrder === 'Y');
    setComMask(maskFlag);
  }, [cardInfo]);

  return (
    <div
      className={`${styles.offerCard} ${isSelected && styles.offerSelect}`}
      onClick={() => onClick(cardInfo)}
    >
      <div className={styles.offerDetail}>
        <div className={styles.detailItem}>
          <Radio checked={isSelected} />
          <span className={styles.title}>{i18n('SELECT_OFFER_PLAN_NAME')}</span>
          <span className={styles.text}>{cardInfo.offerName}</span>
        </div>
        <div className={`${styles.detailItem} ${styles.cardRight}`}>
          <div className={styles.itemBox}>
            <span className={styles.title}>{i18n('SELECT_OFFER_PLAN_PRICE')}</span>
            <span className={styles.text}>{renderPrice(cardInfo.displayRentPrice)}</span>
          </div>
          {
            (['79', '26', '917'].includes(`${servType}`) && !cardInfo.isCombo) && (
              <div className={styles.detailDiv} onClick={handleClick}>
                <img src={detailSvg} alt="" />
                <span>{i18n('SELECT_OFFER_DETAILS')}</span>
              </div>
            )
          }
        </div>
      </div>
      {comMask && <div className={styles.offerMask} />}
      {
        comVisible && (
          <PlanDetail cardInfo={cardInfo} onCancel={handleClick} servType={`${servType}`} />
        )
      }
    </div>
  );
};

export default CardItem;
